import CookieUtils from 'utils/CookieUtils'
import conf from 'conf'

function hasWebConsent() {
  try {
    const raw = CookieUtils.getCookie('gdpr_settings')
    if (!raw || typeof raw !== 'string') return false
    const gdprSettings = raw
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)

    return gdprSettings.includes('web') || gdprSettings.includes('adv')
  } catch {
    return false
  }
}

function ensureQueue() {
  if (typeof window === 'undefined') return false
  if (!Array.isArray(window.ScarabQueue)) {
    window.ScarabQueue = []
  }
  return true
}

function canTrack() {
  return hasWebConsent() && ensureQueue()
}

export function setSAPEmail(email) {
  if (!canTrack() || !email) return false
  window.ScarabQueue.push(['setEmail', email])
  window.ScarabQueue.push(['go'])
  return true
}

export function setSAPId(id) {
  if (!canTrack() || !id) return false
  window.ScarabQueue.push(['setCustomerId', id])
  window.ScarabQueue.push(['go'])
  return true
}

function withEmarsysSdk(task) {
  if (typeof window === 'undefined' || !hasWebConsent()) {
    return Promise.resolve(false)
  }

  return new Promise((resolve) => {
    window.WebEmarsysSdk = window.WebEmarsysSdk || []
    window.WebEmarsysSdk.push(() => {
      Promise.resolve()
        .then(() => task(window.WebEmarsysSdk))
        .then((result) => resolve(Boolean(result)))
        .catch((e) => {
          console.error('[Emarsys] contact link error:', e)
          resolve(false)
        })
    })
  })
}

function isKnownContact(current) {
  return Boolean(current) && current.fieldId !== undefined && Boolean(current.fieldValue)
}

export function syncSAPContact(pinsNumber) {
  if (!pinsNumber || !conf.sapLoginFieldID) {
    return Promise.resolve(false)
  }

  const contact = {
    fieldId: Number(conf.sapLoginFieldID),
    fieldValue: String(pinsNumber)
  }

  return withEmarsysSdk(async (sdk) => {
    if (!(await sdk.isSubscribed())) {
      return false
    }

    const current = await sdk.getLoggedInContact()
    if (
      isKnownContact(current) &&
      current.fieldId === contact.fieldId &&
      current.fieldValue === contact.fieldValue
    ) {
      return true
    }

    const linked = await sdk.login(contact)
    if (!linked) {
      console.warn('[Emarsys] contact link rejected by SDK', contact.fieldId)
    }

    return linked
  })
}

export function unlinkSAPContact() {
  return withEmarsysSdk(async (sdk) => {
    if (!isKnownContact(await sdk.getLoggedInContact())) {
      return true
    }

    return sdk.logout()
  })
}
